import { render, staticRenderFns } from "./FailureType.vue?vue&type=template&id=14d0a7db"
import script from "./FailureType.vue?vue&type=script&lang=ts"
export * from "./FailureType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports